import './ContentWrapper.scss'

export const ContentWrapper = ({ children }) => <div className='content-wrapper'>{children}</div>
